import React, { useState } from "react";
import pdf from "../../Assets/ShahidResume[v1.0].pdf";
import SocialPopup from "../Home/SocialPopup";

function ResumeNew() {
  const [showResume, setShowResume] = useState(false);

  return (
    <section className="resume-section" id="resume">
      <div className="resume-bg" aria-hidden="true">
        <div className="resume-orb resume-orb-a" />
        <div className="resume-orb resume-orb-b" />
      </div>

      <div className="resume-inner">
        <div className="resume-header">
          <span className="section-tag">› experience</span>
          <h2 className="section-heading">
            My Resume<br />
            <em>& Track Record</em>
          </h2>
          <p className="section-sub">
            Download my resume or view details below.
          </p>
        </div>

        <div className="resume-actions">
          <a
            href={pdf}
            target="_blank"
            rel="noreferrer"
            className="cta-primary"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
            </svg>
            Download CV
          </a>
          <button
            className="cta-secondary"
            onClick={() => setShowResume(!showResume)}
          >
            {showResume ? "Hide Resume" : "Show Resume"}
          </button>
        </div>

        {showResume && (
          <div className="resume-preview">
            <iframe
              src={pdf}
              title="Resume Preview"
              width="100%"
              height="600px"
            />
          </div>
        )}

        <div className="resume-cta">
          <p className="resume-cta-title">Interested in working together?</p>
          <p className="resume-cta-sub">Let's discuss your project requirements and how I can help.</p>
          <div className="resume-cta-flex">
            <a
              href="#contacts"
              className="cta-primary"
              onClick={(e) => { e.preventDefault(); document.getElementById("contacts")?.scrollIntoView({ behavior: "smooth" }); }}
            >
              Get in Touch
            </a>
            <a
              href="#projects"
              className="cta-secondary"
              onClick={(e) => { e.preventDefault(); document.getElementById("projects")?.scrollIntoView({ behavior: "smooth" }); }}
            >
              View My Work
            </a>
          </div>
        </div>

        <div className="resume-social">
          <SocialPopup />
        </div>
      </div>

      <style>{`
        .resume-section {
          position: relative;
          padding: 100px 6vw;
          background: var(--bg);
          min-height: 100vh;
          overflow: hidden;
        }

        .resume-bg {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 0;
        }
        .resume-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
        }
        .resume-orb-a {
          width: 350px; height: 350px;
          background: radial-gradient(circle, rgba(45,220,180,0.1), transparent 70%);
          top: 10%; left: 5%;
        }
        .resume-orb-b {
          width: 280px; height: 280px;
          background: radial-gradient(circle, rgba(139,114,255,0.1), transparent 70%);
          bottom: 15%; right: 10%;
        }

        .resume-inner {
          position: relative;
          z-index: 10;
          max-width: 900px;
          margin: 0 auto;
        }

        .resume-header {
          margin-bottom: 40px;
        }

        .resume-actions {
          display: flex;
          gap: 16px;
          margin-bottom: 30px;
          flex-wrap: wrap;
        }

        .resume-preview {
          margin-bottom: 40px;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid var(--border);
          background: var(--surface);
        }
        .resume-preview iframe {
          border: none;
        }

        .resume-cta {
          padding: 40px;
          background: var(--surface);
          border: 1px solid var(--border);
          border-radius: 16px;
          margin-bottom: 40px;
        }
        .resume-cta-title {
          font-family: var(--ff-display);
          font-size: 1.6rem;
          font-weight: 400;
          color: var(--text);
          margin: 0 0 8px;
        }
        .resume-cta-sub {
          font-size: 0.95rem;
          color: var(--muted);
          margin: 0 0 24px;
        }

        .resume-cta-flex {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }

        .resume-social {
          text-align: center;
        }

        @media (max-width: 680px) {
          .resume-section { padding: 80px 5vw; }
          .resume-actions { flex-direction: column; }
          .resume-cta { padding: 30px 20px; }
          .resume-cta-flex { flex-direction: column; }
        }
      `}</style>
    </section>
  );
}

export default ResumeNew;